// @flow
import * as React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import type { LeafletContext } from 'react-leaflet/lib/types';
import { withLeaflet } from 'react-leaflet';
import { withRouter } from 'react-router';
import { isEqual, sortBy } from 'lodash';
import RowActions from 'esm-web-pro/components/layout/sidePanel/RowActions';
import MeatballsIcon from 'esm-web-pro/components/layout/sidePanel/icons/MeatballsIcon';
import actionMessages from 'esm-web-pro/messages/actionMessages';
import { point12Messages } from 'esm-web-pro/messages/points12Messages';
import Point12Cable from 'esm-web-pro/containers/pages/network/objects/point11/Point12Cable';
import BaseEditor from 'esm-web-pro/containers/map/editor/BaseEditor';
import { numberPointsCallbacksCable } from 'esm-web-pro/containers/pages/network/objects/cable/MapCable';
import UseHighlightCable from 'esm-web-pro/containers/pages/network/objects/cable/useHighlightCable';
import ContentRow from 'esm-web-pro/components/layout/sidePanel/ContentRow';
import ValueText from 'esm-web-pro/components/layout/sidePanel/ValueText';


type Props = {
    point: Object,
    point11: Object,
    intl: IntlShape,
    onDisconnectCable: Function,
    getCableData: Function,
    onClick: Function,
    history: Object,
    // eslint-disable-next-line react/no-unused-prop-types
    match: Object,
    mapIsDraft: boolean,
    editor: BaseEditor,
    leaflet: LeafletContext,
    clicked: ?string,
    setClicked: Function,
};

const Point12WithCables = (props: Props) => {
    const {
        point, intl: { formatMessage }, onDisconnectCable, history: { push }, match: { url },
        mapIsDraft, onClick, editor, leaflet: { map }, clicked, setClicked, point11, getCableData,
    } = props;

    const handleHighlight = (cable) => {
        editor.unregisterAllLoadingCallback();
        const point11Coordinates = [...point11.coordinates.coordinates].reverse();
        let path = cable.path.map((c) => [c[1], c[0]]);

        if (!isEqual(point11Coordinates, path[0])) {
            path = path.reverse();
        }

        const focusCableCallback = UseHighlightCable(path);
        editor.registerLoadingCallback(focusCableCallback);
        editor.registerMultipleLoadingCallbacks(numberPointsCallbacksCable(cable));

        if (map) {
            map.highlightedGeometry = {
                bounds: path, center: point11Coordinates,
            };
            map.flyToBoundsCenter(path, point11Coordinates);
        }
        editor.reloadFeatures();
        setClicked(`cable-${cable.id}`);
    };

    const pointActions = [
        {
            key: `point-${point.id}-more`,
            icon: <MeatballsIcon />,
            size: '20px',
            width: '3px',
            callback: (e: SyntheticMouseEvent<HTMLButtonElement>) => {
                e.stopPropagation();
                const path = url.split('/layer');
                push(`${path[0]}/layer/${point.type}/${point.identity}`);
            },
            tooltip: formatMessage(actionMessages.more),
        },
    ];

    return (
        <>
            <ContentRow
                actions={<RowActions actions={pointActions} />}
                onClick={() => onClick(point)}
                rowId={`point-${point.id}`}
                clickedRowIdentity={clicked}
                padLevel={point11.type === 'pop' ? 2 : 1}
            >
                <ValueText>
                    {point.type === 'switch' ? point.oss_switch_name
                        : `${formatMessage(point12Messages[point.type])} ${point.sequence}`}
                </ValueText>
            </ContentRow>
            {sortBy(point.cables, ['sequence']).map((cable) => {
                const message = getCableData(cable);
                return (
                    <Point12Cable
                        key={`point-${point.id}-cable-${cable.id}`}
                        cable={cable}
                        cableKey={cable.id}
                        point={point}
                        mapIsDraft={mapIsDraft}
                        onDisconnectCable={onDisconnectCable}
                        message={message}
                        onHighlight={handleHighlight}
                        clicked={clicked}
                        padLevel={point11.type === 'pop' ? 3 : 2}
                    />
                );
            })}
        </>
    );
};

export default withLeaflet(withRouter(injectIntl(Point12WithCables)));
